import { useTranslation } from "react-i18next";
import { getCurrency } from "../../lib/middleware";

const TamaraSection = ({ data }) => {
    const { t } = useTranslation();
    const currency = getCurrency();
    if (!data?.payment_methods?.tamara || !data.price) return null;
    const installmentAmount = Math.round(data.price / 4);

    return (
        <div className="mt-4 flex items-center justify-between rounded-lg border border-gray-300 bg-white p-4 py-5">
            <p className="text-sm font-normal text-gray-800">
                {t("4_payments_of")}{" "}
                <span className="font-medium">
                    {installmentAmount} {currency}
                </span>{" "}
                {t("with Tamara")}
            </p>

            <img
                src="/payment/tamara.png"
                alt="Tamara"
                className="h-[14px] w-auto"
            />
        </div>
    );
};

export default TamaraSection;
